var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dado",style:(_vm.color)},[_c('div',{staticClass:"title"},[_c('span',[_vm._v(_vm._s(_vm.cell.title))])]),_c('div',{staticClass:"value"},[_c('small',[_vm._v(_vm._s(_vm.cellValue))])])])}
var staticRenderFns = []

export { render, staticRenderFns }